import { render, staticRenderFns } from "./PedidosView.vue?vue&type=template&id=680d74aa"
import script from "./PedidosView.vue?vue&type=script&lang=js"
export * from "./PedidosView.vue?vue&type=script&lang=js"
import style0 from "./PedidosView.vue?vue&type=style&index=0&id=680d74aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports